import {
  DATA_SET_LAYOUT,
  GET_PAGE_STATS,
  POST_CREATE_SUBSCRIPTION,
  SWITCH_PANEL
} from './constants';

export function setLayout(width) {
  return {
    type: DATA_SET_LAYOUT,
    width
  };
}

export function loadPageStats() {
  return dispatch => dispatch({
    type: GET_PAGE_STATS,
    request: {
      method: 'GET',
      endpoint: 'stats/'
    }
  });
}

export function createNewsSubscription(data) {
  return dispatch => dispatch({
    type: POST_CREATE_SUBSCRIPTION,
    request: {
      method: 'POST',
      endpoint: 'subscriptions/',
      data
    }
  });
}

export function switchPanel(panel) {
  return {
    type: SWITCH_PANEL,
    panel
  };
}



// WEBPACK FOOTER //
// ./src/redux/App/actions.js